import axios from 'axios';

const { CONNECTCENTER_API_URL, CONNECTCENTER_API_TOKEN } = process.env;

const apiConnectcenter = axios.create({
    baseURL: CONNECTCENTER_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${CONNECTCENTER_API_TOKEN}`,
    },
});

export { apiConnectcenter };
